<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BpNSSB/tc-custom/9781504001113.jpg?1734041613237" alt="This image is the cover for the book Beloved Stranger, The Scottish Highland Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beloved Stranger, The Scottish Highland Series
      </h1>
      <p class="bookDescription body article font2">
        <b>A wounded warrior and a beautiful English border thief battle treachery, betrayal, and their own warring hearts to satisfy a dangerous, passionate love </b><br/><br/> As the battle at Flodden Field rages, Lachlan Maclean rides with King James IV of Scotland, sworn to vanquish their English enemies and find redemption for the past that haunts him. But as the battlefield runs red with blood, Lachlan realizes they’re fighting a losing battle. Thrown from his horse, he awakens to find a lovely angel of mercy tending him . . . and no memory of who he is.<br/>  <br/> Once, Kimbra Charlton rode alongside her husband on daring border raids that targeted English and Scottish alike. Now the desperate widow combs battlefields for anything of value to make sure she and her young daughter survive. When she stumbles on a wounded soldier, she recognizes the armor and helmet of her people’s sworn enemy. A Scotsman killed her husband, yet she can’t let this man die—nor can the world know his true heritage. It is a secret on which both their lives depend. But as passion ignites between them, they must face the consequences of their impossible love.<br/><br/><b><i>Beloved Stranger </i></b><b>is the 2nd book in the Scottish Highland series, but you may enjoy reading the series in any order.</b><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Potter
      </h2>
      
      <p class="authorDescription body article">Patricia Potter is a <I>USA Today</I>&ndash;bestselling author of more than fifty romantic novels. A seven-time RITA Award finalist and three-time Maggie Award winner, she was named Storyteller of the Year by <I>Romantic Times</I> and received the magazine&rsquo;s Career Achievement Award for Western Romance. Potter is a past board member and president of Romance Writers of America. Prior to becoming a fiction author, she was a reporter for the <I>Atlanta Journal </I>and the president of a public relations firm in Atlanta. She lives in Memphis, Tennessee.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b0e0a22